import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { SettingsItem, SettingsItemContent, SettingsItemDescription, SettingsItemTitle } from 'design-system';
import { IconRocket } from 'design-system/icons/IconRocket';
import IconTransfer from 'design-system/icons/IconTransfer';
import Text from 'design-system/Text';
import { selectAutosaveStatusObj } from 'reducers/selectors';
import Modal from 'utils/packages/Modal';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useDepositToPot from '../hooks/useDepositToPot';
import { useNavigateToAutosave } from '../hooks/useNavigateToAutosave';
const DepositToPotModalContent = ({ pot }) => {
    const navigation = useMainStackNavigation();
    const handleDepositToPot = useDepositToPot(pot);
    const navigateToAutosave = useNavigateToAutosave();
    const autosaveStatusObj = useAppSelector(selectAutosaveStatusObj);
    const isPaused = useAppSelector((state) => state.pots.savingsPlan?.isPaused);
    const savingsPlanMandateStatus = useAppSelector((state) => state.pots.savingsPlan?.mandateStatus);
    const handleDirectDeposit = useCallback(() => {
        Modal.hide(handleDepositToPot);
    }, [handleDepositToPot]);
    const handleAutosave = useCallback(() => {
        if (!savingsPlanMandateStatus) {
            Modal.hide(() => {
                navigation.navigate('AutosaveIntro');
            });
            return;
        }
        if (autosaveStatusObj?.actionRequired) {
            Modal.hide(navigateToAutosave);
            return;
        }
        if (isPaused) {
            Modal.hide(() => {
                navigation.navigate('AutosaveDistribution', { isUnpauseFlow: true });
            });
            return;
        }
        Modal.hide();
    }, [autosaveStatusObj?.actionRequired, isPaused, navigateToAutosave, savingsPlanMandateStatus]);
    return (<>
      <SettingsItem onPress={handleAutosave} icon={<IconRocket gradientKey="darkPurple"/>}>
        <SettingsItemContent>
          <Text Text-12 Primary>
            RECOMMENDED
          </Text>
          <SettingsItemTitle>
            {savingsPlanMandateStatus && !autosaveStatusObj?.actionRequired ? 'Resume Autosave' : 'Autosave'}
          </SettingsItemTitle>
          <SettingsItemDescription>Start saving without thinking with Emma’s automation</SettingsItemDescription>
        </SettingsItemContent>
      </SettingsItem>
      <SettingsItem title="One-off deposit" onPress={handleDirectDeposit} icon={<IconTransfer gradientKey="apricot"/>} description="Top up your pot with a single deposit"/>
    </>);
};
const DepositToPotModal = {
    show: (pot) => {
        Modal.show(<DepositToPotModalContent pot={pot}/>, {
            containerStyle: styles.modal,
            title: 'Choose a way to deposit',
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
export default DepositToPotModal;
